import type { Theme } from '@mui/material';

export const styles = {
  userListFilterSelection: {
    flexGrow: 1,
    overflow: 'auto',
  },

  treeView: {
    overflowX: 'hidden',

    '& .MuiTreeItem-content.Mui-selected': {
      backgroundColor: 'background.selected',

      '&.Mui-focused': {
        backgroundColor: 'background.selected',
      },
    },

    '& .MuiTreeItem-content .MuiTreeItem-iconContainer:empty': {
      display: 'none',
    },
    height: '100%',
  },
  searchFieldWrapper: (theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      minWidth: '18.75rem',
      flexGrow: 1,
      pb: 2,
    },
  }),
  button: {
    whiteSpace: 'normal',
  },
  accordionItem: {
    height: '100%',
  },
  buttonContainer: {
    p: 2,
    mt: 'auto',
  },
  treeWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  treeContainer: {
    flexGrow: 1,
    overflow: 'auto',
  },
};
